import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import OTPField from '~/pages/unAuthorizedPages/LoginScreen/Steps/OTPField';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './ChangeEmailAddress.module.scss';
export const GetOTPInputSectionTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            OTPInputSectionTID: {
                Section: 'one-time-password-section',
                OTPField: 'one-time-password',
                ResendButton: 'resend-code-button'
            }
        }
    });
const OTPInputSection = (param)=>{
    let { isLoading, control, resendCode } = param;
    const { t: changeEmailModalTexts } = useLocaleKeys('components.changeEmailModal');
    const { t: changeEmailAddressTexts } = useLocaleKeys('components.changeEmailAddress');
    const errorMessage = changeEmailAddressTexts.invalidCode();
    const { OTPInputSectionTID } = useMemo(()=>GetOTPInputSectionTID(), []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.sixDigitCodeInput,
        "data-testid": OTPInputSectionTID.Section(),
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "otp",
                rules: {
                    required: errorMessage,
                    minLength: {
                        value: 6,
                        message: errorMessage
                    }
                },
                render: (renderProps)=>/*#__PURE__*/ _jsx(OTPField, _object_spread_props(_object_spread({}, connectControllerToTextField(renderProps), renderProps.field), {
                        testId: OTPInputSectionTID.OTPField(),
                        autoFocus: true,
                        width: 360,
                        mobile: {
                            fluid: true
                        },
                        isLoading: isLoading
                    }))
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'resend_otp_code'
                },
                type: "button",
                testId: OTPInputSectionTID.ResendButton(),
                onClick: resendCode,
                children: changeEmailModalTexts.resendCode()
            })
        ]
    });
};
export default OTPInputSection;
